import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import FirstLessonOverlay from 'views/my_library/overlays/first_lesson/first_lesson_overlay'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import myLibraryActions from 'redux/actions/my_library_actions'

class FirstLessonOverlayContainer extends PureComponent {

	componentDidMount() {
		this.props.actions.firstLessonInitialize()
	}

	render() {
		return (
			<FirstLessonOverlay
				firstLessonFilePicked={this.props.actions.firstLessonFilePicked}
				firstLessonFilePickedError={this.props.actions.firstLessonFilePickedError}
				firstLessonClosed={this.props.actions.firstLessonClosed}
				firstLessonAnimationLoadingCompleted={this.props.actions.firstLessonAnimationLoadingCompleted}
			/>
		)
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		firstLessonFilePicked: myLibraryActions.firstLessonFilePicked,
		firstLessonFilePickedError: myLibraryActions.firstLessonFilePickedError,
		firstLessonClosed: myLibraryActions.firstLessonClosed,
		firstLessonAnimationLoadingCompleted: myLibraryActions.firstLessonAnimationLoadingCompleted,
		firstLessonInitialize: myLibraryActions.firstLessonInitialize,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(FirstLessonOverlayContainer)
